<center-modal [modal]="modal">
    <div class="subscribe-container">
        <div class="header">
            What events would you like to subscribe to?
        </div>
        <div class="subscribe-option ion-activatable" *ngFor="let event of events | keyvalue" (click)="event.value.checked = !event.value.checked">
            <div class="checkbox-container">
                <ion-checkbox [(ngModel)]="event.value.checked" (click)="$event.stopPropagation()"></ion-checkbox>
            </div>
            <div class="text-container">
                <div class="title">
                    {{ event.value.title }}
                </div>
                <div class="description">
                    {{ event.value.description }}
                </div>
            </div>
            <ion-ripple-effect></ion-ripple-effect>
        </div>

        <div class="button-container">
            <ion-toolbar>
                <ion-button slot="end" class="acceptButton" (click)="submitSubscriptions()">OK</ion-button>
            </ion-toolbar>
        </div>
    </div>
</center-modal>